module.exports = __webpack_public_path__ + "media/assets/consultation/project_type_others-7c58e5904c59877d87b67e8c1d02cb06.svg";